<!-- 节能电价设置 -->
<template>
    <div class='container containerBox'>
        <el-form ref="form" :model="form" label-width="120px">
            <el-form-item label="电价">
                <el-input v-model="form.electricity_rule.basic_rate"></el-input>
            </el-form-item>
            <el-form-item label="是否分段计费">
                <el-radio-group v-model="form.electricity_rule.is_basic_rate" :disabled="true">
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="空调系统分成">
                <el-input v-model="form.divided_proportion" @blur="handleBlur('divided_proportion')"></el-input>
            </el-form-item>
            <el-form-item label="水泵分成">
                <el-input v-model="form.pumps_divided_proportion" @blur="handleBlur('pumps_divided_proportion')"></el-input>
            </el-form-item>
            <el-form-item>
            <el-button type="primary" @click="onSubmit">保存</el-button>
        </el-form-item>
</el-form>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import Service from '@/api/Service'
export default {
    name:  '',
    data() {
        return {
            form: {
                electricity_rule:{
                    basic_rate: '',
                    is_basic_rate: true,
                },
                divided_proportion: '',
                pumps_divided_proportion: '',
            }
        };
    },

    components: {},

    computed: {},

    created() {
        this.getData()
    },

    methods: {
        async getData() {
            let res = await Service.getElectricityRule()
            if(res && res.oid) {
                this.form.electricity_rule.basic_rate = res.electricity_rule.basic_rate
                this.form.electricity_rule.is_basic_rate = res.electricity_rule.is_basic_rate
                this.form.divided_proportion = res.divided_proportion
                this.form.pumps_divided_proportion = res.pumps_divided_proportion
                this.form.oid = res.oid
            }
        },
        async onSubmit() {
            if(isNaN(this.form.divided_proportion) || isNaN(this.form.pumps_divided_proportion) || isNaN(this.form.electricity_rule.basic_rate)) {
                this.$message({
                    message: '输入格式有误',
                    type: 'warning'
                })
                return
            }
            let res
            let params = {}
            params.divided_proportion = Number(this.form.divided_proportion)
            
            params.pumps_divided_proportion = this.form.pumps_divided_proportion
            this.form.electricity_rule.basic_rate = Number(this.form.electricity_rule.basic_rate)
            params.electricity_rule = JSON.stringify(this.form.electricity_rule)
            if(this.form.oid) {
                params.oid = this.form.oid
                res = await Service.editElectricityRule(params)
            }else{
                res = await Service.addElectricityRule(params)
            }
            if(res) {
                this.$message({
                    type: 'success',
                    message: '操作成功!',
                });
                this.getData()
            }
        },
        handleBlur(val) {
            if(isNaN(this.form[val]) || this.form[val]<0 || this.form[val]>1) {
                this.$message({
                    message: '分层比例格式错误，请输入0-1之间的小数',
                    type: 'warning'
                })
                setTimeout(() => {
                    this.form[val] = 0
                }, 500);
            }
            
        }
    }
}

</script>
<style lang='less' scoped>

</style>